<script setup lang="ts">
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'
import Modal from '@/components/ui/Modal.vue'

const props = defineProps<{ codes: string[] }>()
const emit = defineEmits<{ done: [] }>()

const { t } = useI18n()
const open = ref(true)

async function copyAll() {
  await navigator.clipboard?.writeText(props.codes.join('\n')).catch(() => {})
}

function finish() {
  open.value = false
  emit('done')
}
</script>

<template>
  <Modal :open="open" :title="t('auth.backup_codes_title')" :show-close="false" @close="() => {}">
    <div class="space-y-4">
      <div class="rounded-md border border-danger/30 bg-danger-light p-3 text-sm text-danger">
        {{ t('auth.backup_codes_warning') }}
      </div>
      <div class="flex flex-wrap justify-center gap-2 font-mono text-base">
        <span v-for="c in codes" :key="c" class="rounded bg-dark px-2 py-1 text-white">{{ c }}</span>
      </div>
      <button type="button" class="btn btn-secondary w-full" @click="copyAll">
        {{ t('auth.copy_all_codes') }}
      </button>
      <button type="button" class="btn btn-primary w-full" @click="finish">
        {{ t('auth.codes_saved') }}
      </button>
    </div>
  </Modal>
</template>
